module.exports = __webpack_public_path__ + "77bb74de03619dc0f819212d5e42e205.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-panel-420.webp.png
// module id = 380
// module chunks = 0